export const createAbility = (user) => {
  if (!user || !user.roles) {
    return false;
  }

  let ability = [];
  user.roles.forEach((role) => {
    role.permissions.forEach((perm) => {
      const name =
        'to' +
        perm.name
          .split(' ')
          .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
          .join('');
      ability[name] = true;
    });
  });
  return Object.assign({}, ability);
};
